import { onboardingStore } from "@/store/store";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import { OnboardingDataV, OnboardingData } from "../types";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";

import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";

export async function saveOnboardingSettings(
  settings?: OnboardingData | string
) {
  if (typeof settings === "undefined") {
    settings = onboardingStore.onboardingData;
  }

  const request = await makeWordPressAjaxRequest({
    action: "breakdance_save_onboarding_settings",
    dataToPost: {
      settings: fpJsonStringify(settings)
    },
    decoder: OnboardingDataV
  });

  return pipe(
    request,
    fold(
      () => false,
      loadedData => {
        onboardingStore.setOnboardingData(loadedData);
        return true;
      }
    )
  );
}

export async function resetOnboardingSettings() {
  const request = await makeWordPressAjaxRequest({
    action: "breakdance_reset_onboarding_settings",
    decoder: OnboardingDataV
  });

  return pipe(
    request,
    fold(
      () => false,
      loadedData => {
        onboardingStore.setOnboardingData(loadedData);
        return true;
      }
    )
  );
}

export async function getOnboardingSettings() {
  const request = await makeWordPressAjaxRequest({
    action: "breakdance_get_onboarding_settings",
    decoder: OnboardingDataV,
    suppressErrorLogging: true
  });

  return pipe(
    request,
    fold(
      () => false,
      loadedData => {
        onboardingStore.setOnboardingData(loadedData);
        return true;
      }
    )
  );
}
